


























import { Component } from "vue-property-decorator";
import MedPartBase from "./MedPartBase";

@Component
export default class TwoMonthAdd extends MedPartBase {
  //在宅患者緊急時カンファレンス
  protected disableCheckHomeUrgentConfFlg(): boolean {
    let result = false;
    if (this.baseDisableCheck()) {
      result = true;
    }
    return result;
  }

  //登録時に、disabledの項目は0にする
  public clearDisableItem() {
    //在宅患者緊急時カンファレンス
    if (this.disableCheckHomeUrgentConfFlg()) {
      this.receiptVisitRecord.home_urgent_conf_flg = 0;
      this.receiptVisitRecord.home_urgent_conf_staff_div = 0;
    }
  }

  //在宅患者緊急時カンファレンス 指導職種 チェック
  protected checkHomeUrgentConfStaffDiv(): boolean | string {
    if (this.receiptVisitRecord.home_urgent_conf_flg > 0) {
      if (this.receiptVisitRecord.home_urgent_conf_staff_div > 0) {
        return true;
      }
      return "必須です";
    }
    return true;
  }
}
